module.exports = __webpack_public_path__ + "img/mianzu.2ca5db84.png";